import { isWeixinBrowser } from '../utils/common';

const systemService = function() {
    var pri = {
        project: null,
        menus: [],
        isWeixinBrowser: null
    }
    var pub = {
        get project_id() {
            return pri.project?.project_id
        },
        get project_caption() {
            return pri.project?.caption
        },
        get menus() {
            return pri.menus ?? []
        },
        get isWeixinBrowser() {
            return pri.isWeixinBrowser ?? isWeixinBrowser()
        },
        // 初始化数据接口
        initData(data) {
            if (data.project) {
                pri.project = data.project
            }

            if (data.menus) {
                pri.menus = data.menus
            }
        }
    }

    // 改为使用 initData 进行加载数据，这样设计器在调试时可以动态加载
    // // 加载项目（由于在 tw_template 项目有自己的静态文件，所以路径使用 / 获取）
    // try {
    //     pri.project = require('/public/static/project.json')
    //     pri.menus = require('/public/static/menus.json')
    // } catch (error) {
    //     console.error(error)
    // }

    return pub;
}

var service = systemService();

export default service;